'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toolbarListModes, _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _ElementToolList = require('./elementTools/ElementToolList');

var _ElementToolList2 = _interopRequireDefault(_ElementToolList);

var _SelectionToolList = require('./selectionTools/SelectionToolList');

var _SelectionToolList2 = _interopRequireDefault(_SelectionToolList);

var _toolbarConstants = require('./toolbarConstants');

require('./ToolList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        selection: state.getIn(['app', 'selection'])
    };
};

var toolbarListModes = (_toolbarListModes = {}, _defineProperty(_toolbarListModes, _toolbarConstants.TOOLBAR_MODES.ELEMENTS, _ElementToolList2.default), _defineProperty(_toolbarListModes, _toolbarConstants.TOOLBAR_MODES.SELECT, _SelectionToolList2.default), _toolbarListModes);

var ToolList = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = function (_React$Component) {
    _inherits(ToolList, _React$Component);

    function ToolList() {
        _classCallCheck(this, ToolList);

        return _possibleConstructorReturn(this, (ToolList.__proto__ || Object.getPrototypeOf(ToolList)).apply(this, arguments));
    }

    _createClass(ToolList, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                selection = _props.selection,
                currentBoardId = _props.currentBoardId,
                gridSize = _props.gridSize;


            var toolbarMode = _toolbarConstants.TOOLBAR_MODES.ELEMENTS;
            // If there is a selection then start in the selected mode
            var selectedIds = selection.get('ids');
            var isSelection = selectedIds.size;
            if (isSelection) {
                toolbarMode = _toolbarConstants.TOOLBAR_MODES.SELECT;
            }

            var ToolListComponent = toolbarListModes[toolbarMode] || _ElementToolList2.default;
            return _react2.default.createElement(ToolListComponent, { currentBoardId: currentBoardId, gridSize: gridSize });
        }
    }]);

    return ToolList;
}(_react2.default.Component)) || _class);
exports.default = ToolList;


ToolList.propTypes = {
    selection: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string.isRequired,
    gridSize: _propTypes2.default.number
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/ToolList.js
// module id = 2217
// module chunks = 0